import AsyncCreatableReactSelect from '@atlaskit/react-select/async-creatable';
import createSelect from './createSelect';
var AsyncCreatableSelect = createSelect(AsyncCreatableReactSelect);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default AsyncCreatableSelect;